import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5002 0.410156L13.891 3.80088L4.96239 12.737L0.644531 13.6658L1.5637 9.34667L10.5002 0.410156ZM10.5002 2.39005L2.84677 10.0435L2.46393 11.8424L4.26407 11.4552L11.9115 3.8013L10.5002 2.39005Z" }));
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
